/**
 * Instantiates a dropdown for selects with the data-sw-dropdown attribute.
 *
 * Usage:
 *
 *   data-sw-dropdown-vendor=<string>
 *     Vendor for the dropdown. Default is minimalect with
 *     support for selectric.
 *
 *   data-sw-dropdown-expand-to-content="true"
 *     Change width of dropdown to adjust for the content of
 *     both the label and the content of the options. Be sure to use
 *     with .sw-dropdown--expand-to-content.
 *
 *   data-sw-dropdown-option-image=<icon url>
 *      Icon in the dropdown.
 *
 *   data-sw-dropdown-option-title=<string>
 *      Main text on the dropdown option.
 *
 *   data-sw-dropdown-label-subtext=<string>
 *      Text that will be appended to the
 *      label.
 *
 *   data-sw-dropdown-option-subtext=<string>
 *      Bold text that will be floated right
 *      on the option.
 *
 *   data-sw-dropdown-ajax-debouce=<time>
 *     Time to debounce request to server.
 *
 *   data-sw-dropdown-placeholder=<placeholder text>
 *     Placeholder text for the dropdown.
 *
 *   data-sw-dropdown-open-placeholder=<open placeholder text>
 *     Placeholder text for the dropdown when it's open.
 *
 *   data-sw-dropdown-ajax=<path>
 *     Path for an ajax search.
 *
 *   data-sw-dropdown-remove-empty-option=<bool>
 *     Whether or not to show the first empty option on a dropdown.
 *
 *   data-sw-dropdown-listen-to-select="true"
 *     Listen to mutations in the options elements and re-render the dropdown if
 *     anything changes. Use this if you are updating options using javascript on the front end.
 *
 *   data-sw-dropdown-option-title=<bool>
 *     Whether or not to show the option name as a title when hovering over the
 *       option (useful for when the dropdown is smaller than the option name and truncated).
 *
 */

var $ =   require('../sw-jquery');
var _ =   require('underscore');
var sw =  require('js/lib/sw');
var optionBuilderTemplate = require('rrTags/templates/tpl.sw-dropdown-option-builder.mustache');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-dropdown]').each(function() {
    var $el = $(this);

    // Avoid double creating dropdowns when the dropdown has already been initiated
    if ($el.data('selectric')) {
      $el.selectric('refresh');
      return;
    }

    var options = {
      listenToSelect: $el.data('swDropdownListenToSelect'),
      expandToContent: $el.data('swDropdownExpandToContent') === true
    };

    var dropdownVendor = $el.data('sw-dropdown-vendor') || 'minimalect',
      selectricDropdown = (dropdownVendor === 'selectric');

    var removeEmptyOption = $el.data('swDropdownRemoveEmptyOption');
    var placeholder = $el.data('swDropdownPlaceholder') || false;
    var openPlaceholder = $el.data('swDropdownOpenPlaceholder') || false;
    var ajaxUrl = $el.data('swDropdownAjax') || false;
    var ajaxDebounce = $el.data('swDropdownAjaxDebounce') || 0;
    var showOptionTitle = $el.data('swDropdownOptionTitle') || false;
    var dropdownId = $el.data('swDropdown');

    var params = {
      remove_empty_option:  removeEmptyOption,
      show_reset:           true,
      live:                 false,
      ajax:                 ajaxUrl,
      ajaxDebounce:         parseInt(ajaxDebounce, 10),
      show_title:           showOptionTitle
    };

    if (placeholder) {
      params.placeholder = placeholder;
    }

    var settings = _.defaults(options || {}, params);

    // save the old onclose if it exists
    var _onopen = settings.onopen ? settings.onopen : function(){};

    /**
     * augment onclose to always repopulate the placeholder and
     * trigger the onclose from settings
     */
    function onopen() {
      if (openPlaceholder) {
        var $minEls = $el.siblings('.' + this.class_container).children();
        var $input = $($minEls.first());
        $input.attr('data-placeholder', openPlaceholder);
      }

      _onopen.call(this);
    }

    settings.onopen = onopen;

    // save the old onclose if it exists
    var _onclose = settings.onclose ? settings.onclose : function(){};

    /**
     * augment onclose to always repopulate the placeholder and
     * trigger the onclose from settings
     */
    function onclose() {
      var $minEls = $el.siblings('.' + this.class_container).children();
      var $input = $($minEls.first());
      var names = [];

      $minEls.find('li.' + this.class_selected).each(function(){
        names.push($(this).text());
      });

      if(names.length) {
        // show it up in the input
        $input.text(names.join(', ')).attr('data-placeholder', names.join(', '));
      } else {
        $input.text(this.placeholder).attr('data-placeholder', this.placeholder);
      }

      _onclose.call(this);
    }

    settings.onclose = onclose;

    /**
     * Callback called each time results are filtered when typing.
     * @param results bool Whether or not results have been found.
     * @param queryText string Text sent to query.
     */
    var onFilterCallback = function(results, queryText) {
      sw.trigger('sw-dropdown-filtered', {
        results: results,
        queryText: queryText,
        dropdownId: dropdownId
      });
    };

    if (settings.onfilter) {
      onFilterCallback = function(results, queryText) {
        sw.trigger('sw-dropdown-filtered', {
          results:    results,
          queryText:  queryText,
          dropdownId: dropdownId
        });

        settings.onfilter.apply(this, arguments);
      };
    }

    function optionsItemBuilder(currItem) {
      if (!currItem) {
        return;
      }
      var currItemEl = currItem.element,
        title = currItemEl.attr('data-sw-dropdown-option-title')  || currItemEl.text();
      if (title) {
        /**
         * Transfer all data attributes to the new dropdown option's
         * first child.
         */
        var currItemElData = currItemEl.data(),
          dataAttrs = _.reduce(currItemElData, function(memo, value, key) {
            var keyHyphen = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
            return memo + " data-" + keyHyphen + '="' + value + '"';
          }, '');

        var mustacheView = {
          src: currItemEl.attr('data-sw-dropdown-option-image'),
          title: title,
          subtext: currItemEl.attr('data-sw-dropdown-option-subtext'),
          dataOptionValue: currItemEl.attr('value'),
          dataAttrs: dataAttrs
        };
        return optionBuilderTemplate.render(mustacheView);
      }

      return '';
    }

    function labelBuilder(currItem) {
      if (!currItem) {
        return;
      }
      var currItemEl = currItem.element,
        title = currItemEl.attr('data-sw-dropdown-option-title') || currItemEl.text();
      var labelSubtext = $el.attr('data-sw-dropdown-label-subtext') || null;
      if (title) {
        var mustacheView = {
          src: currItemEl.attr('data-sw-dropdown-option-image'),
          title: title,
          labelSubtext: labelSubtext,
          subtext: null
        };
        return optionBuilderTemplate.render(mustacheView);
      }

      return '';
    }

    /**
     * Determine the width of an element if it
     * were set to auto width.
     *
     * @param $el
     */
    function getAutoWidth($el) {
      var $clone = $el.clone().css({
        width: 'auto',
        position: 'absolute',
        visibility: 'hidden'}
      ).appendTo($el.parent());
      var width = $clone[0].getBoundingClientRect().width;
      $clone.remove();
      return width;
    }

    /***
     * Use Jquery fade to show and hide the dropdown. The other
     * option is have display block on
     * .sw-dropdown-open .sw-dropdown-items.
     */
    function onOpen(el, selectric) {
      var currentWidth;
      if (options.expandToContent) {
        currentWidth = selectric.elements.outerWrapper[0].getBoundingClientRect().width;
        selectric.elements.outerWrapper.outerWidth(currentWidth);
      }
      // fadeIn items container
      selectric.elements.items.fadeIn(selectric.options.transitionTime);
      var autoWidth = getAutoWidth(selectric.elements.outerWrapper);
      if (options.expandToContent && currentWidth && currentWidth !== autoWidth) {
        selectric.elements.outerWrapper.animate({
          width: autoWidth
        }, selectric.options.transitionTime / 3).css('overflow', 'visible');
      }
    }
    function onClose(el, selectric) {
      var currentWidth;
      if (options.expandToContent) {
        currentWidth = selectric.elements.outerWrapper[0].getBoundingClientRect().width;
        selectric.elements.outerWrapper.outerWidth(currentWidth);
      }
      // fadeOut items container
      selectric.elements.items.fadeOut(selectric.options.transitionTime, function() {
        var autoWidth = getAutoWidth(selectric.elements.outerWrapper);
        if (options.expandToContent && currentWidth && currentWidth !== autoWidth) {
          selectric.elements.outerWrapper.animate({
            width: autoWidth
          }, selectric.options.transitionTime / 3).css('overflow', 'visible');
        }
      });
    }
    function onInit(el) {
      $(el).closest('.sw-dropdown-sw-dropdown__select').find('.sw-dropdown-input').attr('aria-label', 'Hidden Label');
    }

    settings.onfilter = onFilterCallback;

    if (selectricDropdown) {

      $el.selectric({
        onOpen: onOpen,
        onClose: onClose,
        onInit: onInit,
        maxHeight: 350,
        stopPropagation: false,
        customClass: {
          prefix: 'sw-dropdown'
        },
        optionsItemBuilder: optionsItemBuilder,
        labelBuilder: labelBuilder,
        disableOnMobile: false,
        nativeOnMobile: false,
        openOnFocus: false,
        responsive: true,
        transitionTime: 150
      });

      /***
       * Create a mutation observer that refreshes dropdown if a node is removed,
       * added, or changed (childList), or if a data attribute changes. This avoids mutations
       * being triggered by changes to class, id, or value since those attributes
       * don't change the nodes in the Selectric dropdown. Selected event change
       * is already being watched by Selectric.
       */
      if (options.listenToSelect) {
        var LocalMutationObserver = window.MutationObserver || null;
        if (LocalMutationObserver) {
          var swMutationObserver = new LocalMutationObserver(function (mutationList) {

            var dataOrNodeUpdate = _.find(mutationList, function (mutation) {
              return mutation.type === "childList" || mutation.attributeName.indexOf('data-sw') === 0;
            });

            if (!_.isUndefined(dataOrNodeUpdate)) {
              $el.selectric('refresh');
            }
          });

          swMutationObserver.observe(this, {
            childList: true,
            attributes: true,
            subtree: true
          });
        }
      }

    } else {
      $el.minimalect(settings);
    }
  });

};

$(document).ready(function() {
  $('body').addClass('sw-dropdown--loaded');
});
